// src/components/Sidebar.jsx
import React from "react";
import { ToggleLeftIcon, LayoutDashboard } from "lucide-react";
import "../css/Sidebar.css";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path) => location.pathname === path; // Check if the current route matches

  const handleNavigation = (path) => {
    navigate(path); // Navigate to the specified route
  };

  return (
    <div
      className={`sidebar h-screen ${
        isOpen ? "w-56" : "w-0"
      } lg:w-56 text-white transition-all duration-300 fixed lg:relative z-50 overflow-y-auto py-4`}
      style={{ backgroundColor: "#1F1E1E", borderRadius: "24px" }}
    >
      <div className="flex items-center justify-center h-16 px-4 mb-4">
        {/* Logo */}
        <img
          src="/assets/Transparent background.png"
          alt="Ducktail Logo"
          onClick={() => handleNavigation("/")}
          className={`h-12 pr-4 ${
            isOpen ? "block" : "hidden"
          } lg:block cursor-pointer`}
        />
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="absolute right-4 text-white lg:hidden font-semibold"
        >
          {isOpen ? <ToggleLeftIcon size={20} /> : ""}
        </button>
      </div>

      {/* Navigation links - Reordered */}
      <nav
        className={`mt-4 mb-5 ${
          isOpen ? "block" : "hidden"
        } lg:block space-y-1`}
      >
        {/* 1. Dashboard */}
        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-4">
            <LayoutDashboard size={18} color="#ffffff" />
          </span>
          <button
            onClick={() => handleNavigation("/builder/dashboard")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/dashboard") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Dashboard
          </button>
        </div>

        {/* 2. Project Enquiry */}
        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/project invite 1.png" // Kept original icon
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <button
            onClick={() => handleNavigation("/builder/projectenquiry")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/projectenquiry")
                ? "bg-[#616161] rounded-xl"
                : ""
            }`}
          >
            Project Enquiry
          </button>
        </div>

        {/* 3. Project Invite */}
        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3">
            <img
              src="/sidebaricons/project invite 1.png"
              alt="Ducktail Logo"
              className="h-6 w-6" // Kept original size & class
            />
          </span>
          <button
            onClick={() => handleNavigation("/builder/projectinvite")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/projectinvite")
                ? "bg-[#616161] rounded-xl"
                : ""
            }`}
          >
            Project Invite
          </button>
        </div>

        {/* 4. Services */}
        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/Services2.png"
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <a
            href=" " // Kept href for consistency, onClick handles nav
            onClick={() => handleNavigation("/builder/projectservices")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/projectservices")
                ? "bg-[#616161] rounded-xl"
                : ""
            }`}
          >
            Services
          </a>
        </div>

        {/* 5. Portfolio */}
        <div className={`relative `}>
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/Portfolio5.png"
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <a
            href=" " // Kept href for consistency, onClick handles nav
            onClick={() => handleNavigation("/builder/portfolio")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/portfolio") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Portfolio
          </a>
        </div>

        {/* 6. Live Project */}
        <div className={`relative`}>
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/Job list3.png" // Kept original icon
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <button
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/liveproject") ? "bg-[#616161] rounded-xl" : ""
            }`}
            onClick={() => handleNavigation("/builder/liveproject")}
          >
            Live Project
          </button>
        </div>

        {/* 7. Hold Project */}
        <div className={`relative`}>
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/live1.png" // Kept original icon
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <button
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/holdproject") ? "bg-[#616161] rounded-xl" : ""
            }`}
            onClick={() => handleNavigation("/builder/holdproject")}
          >
            Hold Project
          </button>
        </div>

        {/* 8. Rejected Projects */}
        <div className={`relative`}>
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/rejected1.png"
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <a
            href=" " // Kept href for consistency, onClick handles nav
            onClick={() => handleNavigation("/builder/rejectionproject")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/rejectionproject")
                ? "bg-[#616161] rounded-xl"
                : ""
            }`}
          >
            Rejected Projects
          </a>
        </div>

        {/* 9. Completion Request */}
        <div className={`relative`}>
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/faq_1761715511.png" // Kept original icon
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <a
            href=" " // Kept href for consistency, onClick handles nav
            onClick={() => handleNavigation("/builder/completionrequest")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/completionrequest")
                ? "bg-[#616161] rounded-xl"
                : ""
            }`}
          >
            Completion Request
          </a>
        </div>

        {/* 10. Completed Projects */}
        <div className={`relative`}>
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/Profile 2.png" // Kept original icon
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <a
            href=" " // Kept href for consistency, onClick handles nav
            onClick={() => handleNavigation("/builder/completedproject")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/completedproject")
                ? "bg-[#616161] rounded-xl"
                : ""
            }`}
          >
            Completed Projects
          </a>
        </div>

        {/* 11. Subscription History */}
        <div className={`relative`}>
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/rejected1.png" // Kept original icon (Consider changing if needed)
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <a
            href=" " // Kept href for consistency, onClick handles nav
            onClick={() => handleNavigation("/builder/subscriptionhistory")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/subscriptionhistory")
                ? "bg-[#616161] rounded-xl"
                : ""
            }`}
          >
            Subscription History
          </a>
        </div>

        {/* 12. Subscription */}
        <div className={`relative`}>
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/rejected1.png" // Kept original icon (Consider changing if needed)
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <a
            href=" " // Kept href for consistency, onClick handles nav
            onClick={() => handleNavigation("/builder/subscription")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/subscription") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Subscribption {/* Kept original typo */}
          </a>
        </div>

        {/* 13. Profile */}
        <div className={`relative`}>
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/Profile1.png"
              alt="Ducktail Logo"
              className="h-6" // Kept original size
            />
          </span>
          <a
            href=" " // Kept href for consistency, onClick handles nav
            onClick={() => handleNavigation("/builder/profile")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/profile") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Profile
          </a>
        </div>

        {/* 14. Jobs (New) */}
        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
            <img
              src="/sidebaricons/Job list3.png" // Using existing icon
              alt="Jobs Icon"
              className="h-6"
            />
          </span>
          <button
            onClick={() => handleNavigation("/builder/jobs")} // TODO: Create /builder/jobs route and page
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/builder/jobs") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Jobs
          </button>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
